import COS from 'cos-js-sdk-v5';
import { fetchCosTempCredential } from '@/api/index'
import { Toast } from 'vant'
// console.log(COS.version);  sdk 版本需要不低于 1.8.3
const cos = new COS({
    // 其他配置项可参考下方 初始化配置项
    // getAuthorization 必选参数
    getAuthorization: function (options, callback) {
        // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
        // 异步获取临时密钥
        // 服务端 JS 示例：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
        // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
        // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
        fetchCosTempCredential().then(credentials => {
            callback({
                TmpSecretId: credentials.tmpSecretId,
                TmpSecretKey: credentials.tmpSecretKey,
                SecurityToken: credentials.sessionToken,
                // 建议返回服务器时间作为签名的开始时间，避免客户端本地时间偏差过大导致签名错误
                StartTime: credentials.serverTime, // 时间戳，单位秒，如：1580000000
                ExpiredTime: credentials.expiration, // 时间戳，单位秒，如：1580000000
                ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
            });
        })
    }
});

export default cos;